<div class="app-container">
  @if (showNavbar()) {
    <app-navbar />
  }

  <router-outlet />

  @if (showNavbar()) {
    <app-footer />
  }
</div>
